import toast from "react-hot-toast";

import Alert from "@/components/atoms/Alert";

type BannerProps = {
  id?: string;
  size?: "sm" | "md";
  color?: "info" | "success" | "warning" | "error";
  heading: string;
  onClose?: () => void;
  isCloseable?: boolean;
  children?: React.ReactNode;
  isSelfClosing?: boolean;
};

export const useAlert = () => {
  const showAlert = ({
    id,
    size = "md",
    color = "info",
    heading,
    onClose,
    isCloseable = true,
    isSelfClosing = true,
    children,
  }: BannerProps) => {
    toast.custom(
      (t) => (
        <Alert
          size={size}
          color={color}
          heading={heading}
          isVisible={t.visible}
          isCloseable={isCloseable}
          onClose={() => {
            if (onClose) onClose();
            toast.dismiss(t.id);
          }}
        >
          {children}
        </Alert>
      ),
      {
        id: id,
        duration: isSelfClosing ? undefined : Infinity,
      },
    );
  };

  return { showAlert };
};
